/* =========================================================================
   ALUA — Intense Hydration PDP
   Behaviour for the alua-ih-* sections. Ported 1:1 from hydration.html.
   Runs alongside alua-hh.js safely: separate global, separate data- markers.
   Safe to load more than once: every binding is guarded, so re-running
   (theme editor section reload, duplicate script tag) never double-binds.
   Nothing here touches markup outside a .aih wrapper.
   ========================================================================= */
(function () {
  'use strict';

  if (window.AluaIH) { window.AluaIH.init(); return; }

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) {
    if (!el || el.getAttribute('data-aih-' + key) === '1') return false;
    el.setAttribute('data-aih-' + key, '1');
    return true;
  }

  /* ---------- reveal on scroll ------------------------------------------ */
  function countTo(el, to, suf, dur) {
    var st = performance.now();
    (function step(n) {
      var k = Math.min(1, (n - st) / dur);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))) + suf;
      if (k < 1) requestAnimationFrame(step);
    })(performance.now());
  }

  function reveals() {
    var els = all('.aih .reveal').filter(function (e) { return once(e, 'reveal'); });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        all('[data-count]', e.target).forEach(function (n) {
          countTo(n, +n.getAttribute('data-count'), n.getAttribute('data-suffix') || '', 900);
        });
        io.unobserve(e.target);
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    /* safety net — if the observer never fires, show the content anyway */
    setTimeout(function () { els.forEach(function (e) { e.classList.add('in'); }); }, 2500);
  }

  /* ---------- accordions (product buy-box + FAQ section) ---------------- */
  function accordions() {
    all('.aih .faq-q').forEach(function (q) {
      if (!once(q, 'faq')) return;
      q.addEventListener('click', function () {
        var f = q.parentElement, a = q.nextElementSibling;
        var open = f.classList.toggle('open');
        if (a) a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });
    /* keep an open panel correctly sized after a resize */
    if (once(document.documentElement, 'faqresize')) {
      window.addEventListener('resize', function () {
        all('.aih .faq.open .faq-a').forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
      });
    }
  }

  /* ---------- marquee ---------------------------------------------------- */
  function marquee() {
    all('.aih .marq-track').forEach(function (m) {
      if (!once(m, 'marq')) return;
      var base = m.innerHTML, guard = 0;
      while (m.scrollWidth < window.innerWidth * 1.25 && guard < 24) { m.innerHTML += base; guard++; }
      m.innerHTML += m.innerHTML;
    });
  }

  /* ---------- scroll progress bar ---------------------------------------- */
  function progress() {
    var bars = all('.aih .progress').filter(function (b) { return once(b, 'prog'); });
    if (!bars.length) return;
    var upd = function () {
      var h = document.documentElement;
      var st = h.scrollTop || document.body.scrollTop;
      var sh = h.scrollHeight - h.clientHeight;
      var w = (sh > 0 ? (st / sh) * 100 : 0) + '%';
      bars.forEach(function (b) { b.style.width = w; });
    };
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---------- product gallery -------------------------------------------- */
  function gallery() {
    all('.aih .gallery').forEach(function (g) {
      if (!once(g, 'gal')) return;
      var root = g.closest('.aih') || document;
      var hero = root.querySelector('[data-aih-hero]');
      var thumbs = all('.thumb', g);
      if (!thumbs.length) return;

      thumbs.forEach(function (th) {
        th.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('active'); });
          th.classList.add('active');
          var img = th.querySelector('img');
          var full = img && img.getAttribute('data-full');
          if (full && hero) hero.src = full;
          if (hero && img && img.alt) hero.alt = img.alt;
          try { th.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (e) {}
        });
      });

      function go(dir) {
        var i = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
        if (i < 0) i = 0;
        i = (i + dir + thumbs.length) % thumbs.length;
        thumbs[i].click();
      }
      var p = g.querySelector('[data-aih-gprev]'), n = g.querySelector('[data-aih-gnext]');
      if (p) p.addEventListener('click', function () { go(-1); });
      if (n) n.addEventListener('click', function () { go(1); });
    });
  }

  /* ---------- sticky add-to-cart bar -------------------------------------- */
  function sticky() {
    all('.aih .sticky-cta').forEach(function (bar) {
      if (!once(bar, 'sticky')) return;
      var target = document.querySelector('.aih .buy') || document.querySelector('#MainProduct');
      var go = bar.querySelector('[data-aih-stickygo]');
      if (go) {
        go.addEventListener('click', function () {
          var t = document.querySelector('.aih .buy-card') || target;
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      if (!target || !('IntersectionObserver' in window)) return;
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('show', !e.isIntersecting); });
      }, { threshold: 0 });
      so.observe(target);
    });
  }

  /* ---------- symptom wheel ----------------------------------------------
     Each button carries its own caption in data-cap, so the copy lives in the
     section settings rather than a global JS lookup table. */
  function symptoms() {
    all('.aih .symwrap').forEach(function (wrap) {
      if (!once(wrap, 'sym')) return;
      var cap = wrap.querySelector('.sym-cap');
      var btns = all('.sx', wrap);
      if (!btns.length || !cap) return;

      function select(btn) {
        btns.forEach(function (b) { b.classList.toggle('on', b === btn); });
        var text = btn.getAttribute('data-cap');
        if (!text) return;
        if (RM) { cap.innerHTML = text; return; }
        cap.style.opacity = 0;
        setTimeout(function () { cap.innerHTML = text; cap.style.opacity = 1; }, 140);
      }

      cap.style.transition = RM ? 'none' : 'opacity .25s cubic-bezier(.22,.61,.36,1)';
      btns.forEach(function (b) {
        b.addEventListener('click', function () { select(b); });
      });
    });
  }

  /* ---------- review slider (transform based, drag + arrows + dots) ------- */
  function ugc() {
    all('.aih .ugc-scroll').forEach(function (track) {
      if (!once(track, 'ugc')) return;
      var cards = Array.prototype.slice.call(track.children);
      if (cards.length < 2) return;
      var GAP = 18;

      var vp = document.createElement('div');
      vp.className = 'ugc-vp';
      track.parentNode.insertBefore(vp, track);
      vp.appendChild(track);
      track.classList.add('is-slider');

      var ctrl = track.parentNode.parentNode.querySelector('.ugc-controls');
      var nav = document.createElement('div');
      nav.className = 'ugc-nav';
      var prev = document.createElement('button'), next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = 'ugc-arrow prev';
      next.className = 'ugc-arrow next';
      prev.setAttribute('aria-label', 'Vorige reviews');
      next.setAttribute('aria-label', 'Volgende reviews');
      prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
      var dots = document.createElement('div');
      dots.className = 'ugc-dots';
      nav.appendChild(prev); nav.appendChild(dots); nav.appendChild(next);
      if (ctrl) { ctrl.style.display = 'none'; ctrl.parentNode.insertBefore(nav, ctrl.nextSibling); }
      else vp.parentNode.insertBefore(nav, vp.nextSibling);

      var idx = 0, per = 1, maxIdx = 0, step = 0;

      function perView() {
        var w = vp.clientWidth;
        if (w < 620) return 1;
        if (w < 880) return 2;
        if (w < 1100) return 3;
        return 4;
      }
      function buildDots() {
        if (dots.children.length === maxIdx + 1) return;
        dots.innerHTML = '';
        for (var i = 0; i <= maxIdx; i++) {
          (function (i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'ugc-dot';
            d.setAttribute('aria-label', 'Ga naar review ' + (i + 1));
            d.addEventListener('click', function () { go(i); });
            dots.appendChild(d);
          })(i);
        }
        dots.style.display = maxIdx > 0 ? '' : 'none';
        nav.style.display = maxIdx > 0 ? '' : 'none';
      }
      function layout() {
        per = perView();
        var w = vp.clientWidth;
        var cw = (w - GAP * (per - 1)) / per;
        cards.forEach(function (c) { c.style.flex = '0 0 ' + cw + 'px'; c.style.maxWidth = cw + 'px'; });
        step = cw + GAP;
        maxIdx = Math.max(0, cards.length - per);
        if (idx > maxIdx) idx = maxIdx;
        buildDots();
        go(idx, true);
      }
      function go(i, instant) {
        idx = Math.max(0, Math.min(maxIdx, i));
        track.style.transition = instant ? 'none' : 'transform .55s cubic-bezier(.22,.61,.36,1)';
        track.style.transform = 'translate3d(' + (-idx * step) + 'px,0,0)';
        Array.prototype.forEach.call(dots.children, function (d, n) { d.classList.toggle('on', n === idx); });
        prev.disabled = idx === 0;
        next.disabled = idx === maxIdx;
      }
      prev.addEventListener('click', function () { go(idx - 1); });
      next.addEventListener('click', function () { go(idx + 1); });

      var down = false, x0 = 0, dx = 0;
      function start(e) {
        down = true; dx = 0;
        x0 = (e.touches ? e.touches[0].clientX : e.clientX);
        track.style.transition = 'none';
        track.classList.add('grabbing');
      }
      function move(e) {
        if (!down) return;
        dx = (e.touches ? e.touches[0].clientX : e.clientX) - x0;
        track.style.transform = 'translate3d(' + (-idx * step + dx) + 'px,0,0)';
      }
      function end() {
        if (!down) return;
        down = false;
        track.classList.remove('grabbing');
        if (Math.abs(dx) > step * 0.18) go(idx + (dx < 0 ? 1 : -1)); else go(idx);
      }
      track.addEventListener('mousedown', function (e) { e.preventDefault(); start(e); });
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      track.addEventListener('touchstart', start, { passive: true });
      track.addEventListener('touchmove', move, { passive: true });
      track.addEventListener('touchend', end);

      window.addEventListener('resize', layout);
      layout();
    });
  }

  /* ---------- ingredient-style modal used by the buy-box link buttons ----- */
  function modals() {
    all('.aih [data-aih-modal]').forEach(function (modal) {
      if (!once(modal, 'modal')) return;
      var scope = modal.closest('.aih') || document;
      var content = modal.querySelector('[data-aih-modal-content]');
      function open(img) {
        content.innerHTML = img
          ? '<img src="' + img + '" alt="">'
          : '<div class="im-placeholder"><div class="imp-t">Afbeelding nodig</div><div class="imp-d">Voeg hier de definitieve afbeelding toe</div></div>';
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
      function close() {
        modal.classList.remove('open');
        document.body.style.overflow = '';
      }
      all('.ing-btn', scope).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); open(b.getAttribute('data-img')); });
      });
      var bd = modal.querySelector('.im-backdrop'), cl = modal.querySelector('.im-close');
      if (bd) bd.addEventListener('click', close);
      if (cl) cl.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- boot -------------------------------------------------------- */
  function init() {
    reveals();
    accordions();
    marquee();
    progress();
    gallery();
    sticky();
    symptoms();
    ugc();
    modals();
  }

  window.AluaIH = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* theme editor: re-run when a section is added, moved or re-rendered */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();